// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { ExecutedTransfer } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Holding/Transfer';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../../other/useQueryWithOptions';

const useExecutedTransfers: () => UseQueryResult<
  TemplateContract<ExecutedTransfer>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();

  return useQueryWithOptions({
    queryKey: ['queryExecutedTransfers', operator],
    enabled: !!operator,
    select: (data: TemplateContract<ExecutedTransfer>[]) =>
      data.filter((d) => d.payload.transfer.operator === operator),
    queryFn: async (_, options) => {
      return ledgerApi.query(options, ExecutedTransfer);
    },
  });
};

export default useExecutedTransfers;
